<div class="media-asset w-full h-full">
  <div class="media-asset-visualizer !items-start">
    <div *ngIf="docLoading" class="flex flex-row items-center justify-center w-full h-full z-1000 top-0 left-0 absolute bg-[#F4F3F3]">
      <mat-spinner diameter="30" class="m-2" color="warn"></mat-spinner> Please wait, loading...
    </div>
    <iframe *ngIf="iframeUrl" #iframeRef [src]="iframeUrl | safePipe : 'url'" title="Powerpoint presentation" class="w-full h-full"></iframe>
  </div>
</div>
